<p class="mb-3">
  <a target="_blank" [href]="url">{{ this.attachment.nameOriginal | pepAttachmentEllipsis: 35 }} <i class="fe fe-external-link"></i></a>
</p>
